import api from "../config";
import URLS from "../../constants/urls";
export const _getApiKeys = async (siteId) => {
    const response = await api.get(`${URLS.API_KEY}/${siteId}`);
    return response.data;
};
export const _createApiKey = async (data) => {
    const response = await api.post(`${URLS.API_KEY}/create`, data);
    return response.data;
};
export const _disableApiKey = async (siteId, apiKeyId) => {
    const response = await api.put(`${URLS.API_KEY}/${siteId}/${apiKeyId}/disable`);
    return response.data;
};
export const _enableApiKey = async (siteId, apiKeyId) => {
    const response = await api.put(`${URLS.API_KEY}/${siteId}/${apiKeyId}/enable`);
    return response.data;
};
export const _deleteApiKey = async (siteId, apiKeyId) => {
    const response = await api.delete(`${URLS.API_KEY}/${siteId}/${apiKeyId}`);
    return response.data;
};
